import { useTranslation } from 'react-i18next';

import { BaseIngredientTabProps } from 'components/desktop/BaseIngredient/BaseIngredientComponent';
import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import RoundedInput from 'components/desktop/_general/Input/RoundedInput/RoundedInput';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

export const BaseIngredientDensityCard = ({
	state,
	handlers,
}: BaseIngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	const isBaseIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEBASEINGREDIENT,
	]);

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="baseingredient-density-card"
			title={t('_general:DENSITY')}
			content={
				<>
					<div className="card-body">
						<RoundedInput
							disabled={!isBaseIngredientEditor}
							error-key="Density"
							handleChange={handlers.setDensity}
							name="density"
							value={state.density ?? 0}
						/>
					</div>
				</>
			}
		/>
	);
};
